module.exports = __webpack_public_path__ + "static/product5-b-f6b68fcc226cfa780434a3da3e1d778b.png";